import { createStyles, makeUiStyles } from '../styles/styles';
import { MarginType } from './ComponentStyled';
import { StylesIndexInjections } from 'common-react';

export interface ComponentStyledStyleProps {
  marginBottom?: MarginType;
  marginTop?: MarginType;
}

export default makeUiStyles(() => createStyles({
  root: {
    marginBottom: ({ marginBottom }: ComponentStyledStyleProps) => marginBottom ? `${marginBottom}px` : undefined,
    marginTop: ({ marginTop }: ComponentStyledStyleProps) => marginTop ? `${marginTop}px` : undefined,
  },
}), { name: 'ComponentStyled', index: StylesIndexInjections.UI_ATOMS });